import { Alert, SimpleGrid, Table } from "@mantine/core";
import BooleanFormSelect from "components/elements/BooleanFormSelect";
import { CustomInput } from "pages/admin/components/CustomInput";
import { CustomNumberInput } from "pages/admin/components/CustomNumberInput2";
import { FormTableLayout } from "pages/admin/components/FormatTableLayout";
import React from "react";
import { ProductManagementChildFormProps } from "types/interface.types";

const ProductDetailsCard1: React.FC<ProductManagementChildFormProps> = ({
  readonly,
  formApi,
}) => {
  const { values, setFieldValue } = formApi;

  return (
    <div className="card-container ">
      {values.closed && <Alert>Product Closed (Not Active)</Alert>}

      <FormTableLayout>
        <Table.Tbody>
          <Table.Tr>
            <Table.Td colSpan={2}>
              <SimpleGrid cols={5} spacing="md">
                <CustomInput
                  readonlyMode={values.id !== 0}
                  label="Product Code"
                  maxLength={9}
                  placeholder=""
                  value={String(values.id)}
                  onChange={(v) => setFieldValue("productCode", v)}
                />
                <CustomInput
                  readonlyMode={readonly}
                  label="Alt Code"
                  maxLength={50}
                  placeholder=""
                  value={values.altCode}
                  onChange={(v) => setFieldValue("altCode", v)}
                />
                <BooleanFormSelect
                  readonlyMode={readonly}
                  label="Closed"
                  value={values.closed}
                  onChange={(v) => setFieldValue("closed", v)}
                />
                <CustomInput
                  readonlyMode={true}
                  label="Supplier Codes"
                  placeholder=""
                  value={values.supplierCode}
                  onChange={(v) => setFieldValue("supplierCode", v)}
                />
                <CustomInput
                  readonlyMode={readonly}
                  label="Measure (CTN)"
                  placeholder=""
                  onChange={(v) => setFieldValue("unitsCtn", Number(v))}
                  value={String(values.unitsCtn)}
                />
              </SimpleGrid>
            </Table.Td>
          </Table.Tr>
          <Table.Tr>
            <Table.Td colSpan={2}>
              <CustomInput
                readonlyMode={readonly}
                label="Product Description"
                maxLength={50}
                placeholder=""
                value={values.productDescription}
                onChange={(v) => setFieldValue("productDescription", v)}
              />
            </Table.Td>
          </Table.Tr>
          <Table.Tr>
            <Table.Td colSpan={2}>
              <SimpleGrid cols={4} spacing="md">
                <CustomInput
                  readonlyMode={readonly}
                  label="Barcode (EA)"
                  maxLength={50}
                  placeholder=""
                  value={values.barcode}
                  onChange={(v) => setFieldValue("barcode", v)}
                />
                <CustomInput
                  readonlyMode={readonly}
                  label="Barcode (CTN)"
                  maxLength={50}
                  placeholder=""
                  value={values.barcodeCtn}
                  onChange={(v) => setFieldValue("barcodeCtn", v)}
                />
                <BooleanFormSelect
                  readonlyMode={readonly}
                  label="Discount?"
                  value={values.noDiscount}
                  onChange={(v) => setFieldValue("noDiscount", v)}
                />
                <CustomNumberInput
                  readonlyMode={readonly}
                  label="Duty %"
                  maxLength={5}
                  placeholder=""
                  value={values.duty}
                  onChange={(v) => setFieldValue("duty", v)}
                />
              </SimpleGrid>
            </Table.Td>
          </Table.Tr>
          <Table.Tr>
            <Table.Td colSpan={2}>
              <SimpleGrid cols={4} spacing="md">
                <CustomNumberInput
                  readonlyMode={readonly}
                  label="Freight Factor (EA)"
                  maxLength={5}
                  placeholder=""
                  value={values.freight}
                  onChange={(v) => setFieldValue("freight", v)}
                />
                <CustomNumberInput
                  readonlyMode={readonly}
                  label="Freight Factor (CTN)"
                  maxLength={5}
                  placeholder=""
                  value={values.freightCtn}
                  onChange={(v) => setFieldValue("freightCtn", v)}
                />
                <CustomNumberInput
                  readonlyMode={readonly}
                  label="Volumne (EA)"
                  maxLength={5}
                  placeholder=""
                  value={values.volumne}
                  onChange={(v) => setFieldValue("volumne", v)}
                />
                <CustomNumberInput
                  readonlyMode={readonly}
                  label="Volumne (CTN)"
                  maxLength={5}
                  placeholder=""
                  value={values.volumneCtn}
                  onChange={(v) => setFieldValue("volumneCtn", v)}
                />
              </SimpleGrid>
            </Table.Td>
          </Table.Tr>
        </Table.Tbody>
      </FormTableLayout>
    </div>
  );
};
export default React.memo(ProductDetailsCard1);
